<div id="hwscan-item-{{ i }}" class="vtr-widget-hardware-scan-item" *ngFor="let item of items; let i = index">
	<div class="container-fluid separator">
		<mat-accordion id="hwscan-item-{{ i }}-accordion" class="vtr-material-expansion-panel">
			<mat-expansion-panel
				#expansionPanel
				panelId="hwscan-item-{{ i }}-panel"
				[disabled]="!isScanExecute || isEnableViewResults || isRecoverExecute"
				[hideToggle]="!isScanExecute || isEnableViewResults || isRecoverExecute"
				[expanded]="shouldExpand(item)"
				(opened)="item.expanded = true;"
				(closed)="item.expanded = false;"
				(click)="setExpandStatusByUserOnClick(item, $event);"
				(keydown)="setExpandStatusByUserOnKeydown(item, $event);">
				<mat-expansion-panel-header-customize class="module">
					<div class="module-information">
						<div class="module-icon" *ngIf="item.icon !== undefined">
							<!-- Defines an icon according to the hardware component -->
							<div class="test-status" [ngSwitch]="item.icon">
								<img id="hwscan-item-{{ i }}-icon" alt="audio_controller" class="img-icon" *ngSwitchCase="'audio_controller'" [src]="'assets/icons/hardware-scan/icon_hardware_audio_controller.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="processor" class="img-icon" *ngSwitchCase="'cpu'" [src]="'assets/icons/hardware-scan/icon_hardware_processor.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="memory" class="img-icon" *ngSwitchCase="'memory'" [src]=" 'assets/icons/hardware-scan/icon_hardware_memory.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="motherboard" class="img-icon" *ngSwitchCase="'motherboard'" [src]=" 'assets/icons/hardware-scan/icon_hardware_motherboard.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="pci_express" class="img-icon" *ngSwitchCase="'pci_express'" [src]=" 'assets/icons/hardware-scan/icon_hardware_pci-desktop.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="pci_express" class="img-icon" *ngSwitchCase="'pci_express_laptop'" [src]=" 'assets/icons/hardware-scan/icon_hardware_pci-laptop.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="wireless" class="img-icon" *ngSwitchCase="'wireless'" [src]=" 'assets/icons/hardware-scan/icon_hardware_wireless.svg' | svgInline | async" />
								<img id="hwscan-item-{{ i }}-icon" alt="storage" class="img-icon" *ngSwitchCase="'storage'" [src]=" 'assets/icons/hardware-scan/icon_hardware_hdd.svg' | svgInline | async" />
							</div>
							<!-- Defines a style title based on the response received -->
							<div class="row">
								<p id="hwscan-item-{{ i }}-module" role="text" class="title">{{ ('hardwareScan.pluginTokens.' + item.module) | translateDefault:item.module }}</p>
								<p id="hwscan-item-{{ i }}-device" role="text" class="subtitle" *ngIf="item.name">{{ ('hardwareScan.pluginTokens.' + item.name) | translateDefault:item.name }}</p>
							</div>
						</div>

						<div class="row not-wrap">
							<!-- Defines a status to module list when finish all subtests -->
							<vtr-ui-hardware-scan-test-result
								*ngIf="item.resultCode"
								[componentId]="'hwscan-item-' + i + '-test-result'"
								[module]="item">
							</vtr-ui-hardware-scan-test-result>
						</div>
					</div>
				</mat-expansion-panel-header-customize>

				<div class="row">
					<!-- Icon to expand and collapse details list -->
					<div *ngIf="isEnableViewResults || item.details"
						id="hwscan-item-{{ i }}-details-btn"
						class="details-link"
						tabindex="0"
						[attr.aria-label]="!item.detailsExpanded ? item.module + 'expand-module-details': item.module + 'collapse-module-details'"
						(click)="item.detailsExpanded = !item.detailsExpanded"
						(keyup.enter)="item.detailsExpanded = !item.detailsExpanded"
						role="button"
						[attr.aria-expanded]="item.detailsExpanded">
						<fa-icon *ngIf="!item.detailsExpanded; else expandIcon" [icon]="['fas', 'caret-right']"></fa-icon>
						<ng-template #expandIcon><fa-icon [icon]="['fas', 'caret-up']"></fa-icon></ng-template>
						<div *ngIf="!item.detailsExpanded; then showDetails else hideDetails"></div>
						<ng-template #showDetails>{{ 'hardwareScan.showDetails' | translate }}</ng-template>
						<ng-template #hideDetails>{{ 'hardwareScan.hideDetails' | translate }}</ng-template>
					</div>
				</div>

				<!-- Details List with information about the module -->
				<div class="row details-list" *ngIf="(isEnableViewResults || item.details) && item.detailsExpanded">
					<table id="hwscan-item-{{ i }}-details" class="table table-details table-active table-borderless">
						<tbody>
							<tr *ngFor="let detail of item.details; let j = index" [ngClass]="{'index-info': detail.key === 'INDEX'}">
								<th class="details-title" id="hwscan-item-{{ i }}-detail-{{ j }}-name">{{ ('hardwareScan.' + (isRecoverExecute ? 'recoverBadSectors.' : 'pluginTokens.') + detail.key) | translateDefault:detail.key }}</th>
								<td id="hwscan-item-{{ i }}-detail-{{ j }}-value">{{ ('hardwareScan.pluginTokens.' + detail.value) | translateDefault:detail.value }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row col">
					<!-- Test List with collapsed running test-->
					<div class="test-list col" *ngIf="isScanExecute && !isEnableViewResults && !isRecoverExecute">
						<vtr-ui-hardware-list
							[componentId]="'hwscan-item-' + i + '-test'"
							[items]="item.listTest"
							[template]="2"
							[isListCollapsed]="!expansionPanel.expanded">
						</vtr-ui-hardware-list>
					</div>

					<!-- Test List with details test-->
					<div class="test-list col" *ngIf="isEnableViewResults || item.details || isRecoverExecute">
						<vtr-ui-hardware-list
							[componentId]="'hwscan-item-' + i + '-test'"
							[items]="item.listTest"
							[template]="2">
						</vtr-ui-hardware-list>
					</div>

					<mat-menu #tooltipRefModule [hasBackdrop]="false" class="vtr-tooltip question-mark-tooltip" xPosition="before" yPosition="center">
						<div mat-menu-item>
							<div aria-live="polite"
								role="text"
								id="hwscan-item-{{ i }}-result-code-tooltip-text"
								[innerHTML]="'hardwareScan.pluginTokens.' + item.information | translateDefault:item.information">
							</div>
						</div>
						<!-- This button is being called as hyperlink instead of global component because of a problem with NVDA read -->
						<div class="hyperlink-box">
							<button
								mat-menu-item
								class="hyperlink-outline"
								id="hwscan-item-{{ i }}-result-code-tooltip-support-link"
								(click)="openContactusPage()"
								[attr.role]="'menuitem'">
									<div class="hyperlink-text-container">
										<span
											class="hyperlink xs-300-lightGray1"
											[innerHTML]="'hardwareScan.support.subtitle' | translate">
										</span>
									</div>
							</button>
						</div>
					</mat-menu>

					<!-- Result code information -->
					<div class="result-code" *ngIf="item.resultCode">
						<p class="title">{{resultCodeText}}:</p>
						<p id="hwscan-item-{{ i }}-result-code-value" role="text" class="subtitle">{{ ('hardwareScan.' + item.resultCode.toLowerCase()) | translateDefault: item.resultCode }}</p>
						<div class="result-code-question-mark">
							<vtr-ui-question-mark-button
								*ngIf="item.information"
								componentId="hwscan-item-{{ i }}-result-code"
								class="question-mark-container"
								[ariaLabel]="item.module + 'result-code'"
								[tooltipReference]="tooltipRefModule"
								[tooltipCloseTrigger]="!expansionPanel.expanded">
							</vtr-ui-question-mark-button>
						</div>
					</div>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
</div>
